import { markRaw } from "vue";
import { MutationTree } from "vuex";
import { ModalAction, ModalState } from "./state";
import { DynamicKeysObject } from "@/utils/type";
import { defineVuexName, MODULES } from "../utils";

const mutations: MutationTree<ModalState> = {
  //open
  [defineVuexName(MODULES.MODAL.COMMITS.OPEN)](
    state: ModalState,
    payload: {
      title: string;
      view: object;
      actions?: ModalAction[];
      props?: DynamicKeysObject;
      name?: string;
    },
  ) {
    state.isOpen = true;
    state.title = payload.title;
    state.view = markRaw(payload.view);
    state.name = payload.name || "";
    if (payload.actions) {
      state.actions = payload.actions;
    }
    if (payload.props) {
      state.props = payload.props;
    } else {
      state.props = {};
    }
  },
  //close
  [defineVuexName(MODULES.MODAL.COMMITS.CLOSE)](state: ModalState) {
    state.isOpen = false;
    state.name = "";
  },
  //setIsSubmitting
  [defineVuexName(MODULES.MODAL.COMMITS.SET_IS_SUBMITTING)](state: ModalState, payload: boolean) {
    state.isSubmitting = payload;
  },
};

export default mutations;
